const clean = (value) => String(value ?? "").replace(/\s+/g, " ").trim();

const comparable = (value) => clean(value)
  .toLocaleLowerCase("uk-UA")
  .replace(/,/g, ".")
  .replace(/\s+/g, "");

export const getProductDisplayName = (product = {}, variant = null) => {
  const selected = variant || product;
  const name = clean(selected?.name || product?.name);
  const weight = clean(selected?.weight ?? product?.weight);

  if (!name) return "";
  if (!weight) return name;

  // Remove only the separator before an already included package size.
  // Keep decimal commas and punctuation within the product name intact.
  const weightPattern = Array.from(weight.replace(/\s+/g, "")).map((part) => {
    if (part === "." || part === ",") return "[.,]";
    return part.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }).join("\\s*");
  const normalizedName = clean(name.replace(
    new RegExp(`(^|[^\\d]|\\d(?=,\\s)),\\s*(${weightPattern})$`, "i"),
    "$1 $2",
  ));
  if (comparable(name).includes(comparable(weight))) return normalizedName;
  return clean(`${name.replace(/,$/, "")} ${weight}`);
};
